import { ScheduledPostType } from '../../types';
import ScheduledPostCard from './ScheduledPostCard';
import { MutableRefObject, useRef, useEffect } from 'react';
import { useInView } from 'motion/react';
import { getTrueDate } from '@/lib/utils';
import { DateTime } from 'luxon';

type DateSectionProps = {
  date: string,
  posts: ScheduledPostType[],
  container: MutableRefObject<HTMLDivElement | null>,
  isInitial: MutableRefObject<boolean>,
  position: string,
  onInView: (id: string) => void,
}

const DateSection = ({ date, posts, position, onInView, isInitial, container }: DateSectionProps) => {
function isDateToday(dateString: string): boolean {
  const inputDate = DateTime.fromISO(dateString, { zone: 'America/New_York' }).startOf('day');
  const today = DateTime.now().setZone('America/New_York').startOf('day');
  
  return inputDate.equals(today);
}
  
  const sectionRef = useRef<HTMLDivElement | null>(null);
  
  const isInView = useInView(sectionRef, { 
    amount: 0.4, 
    root: container 
  });

  useEffect(() => {
    if (isInView && !isInitial.current) {
      onInView(position);
    }
  }, [isInView, onInView, position]);

  useEffect(() => {
    if (isInitial.current) {
      isInitial.current = false;
    }
  }, []);

  return (
    <div className='flex flex-col gap-4 size-full py-4' id={position} ref={sectionRef}>
      <section id="header" className='flex justify-between items-center'>
        <span className='flex items-end justify-start gap-3'>
          <h2 className='text-2xl font-montserrat font-medium'>{isDateToday(date) ? "Today" : getTrueDate(date, "PPP")}</h2>
          <p className='text-xl text-gray-300'>|</p>
          <p className='font-poppins text-md tracking-wide'>{posts.length} posts scheduled</p>
        </span>
      </section>
      <section className='columns-1 md:columns-2 h-full xl:columns-3 gap-4'>
        {posts.map((data, index) => (
          <ScheduledPostCard key={index} date={date} data={data} />
        ))}
      </section>
    </div>
  )
}

export default DateSection;
